<template>
 <Header></Header>
      <!-- 顶部图片 -->
    <div class="top-img-wrapper">
      <img class="wx" v-if="category_sn=='10005'" src="../../assets/picture/800_cd.jpg" alt="背景图" />
      <img class="wx" v-else-if="category_sn=='10002'" src="../../assets/picture/640_yz.png" alt="背景图" />
      <img class="wx" v-else-if="category_sn=='10003'" src="../../assets/picture/640_clj.png" alt="背景图" />
      <img class="wx" v-else src="../../assets/picture/800_cd2.png" alt="背景图" />
      
    </div>

  <div v-if="sfc!=null" class="clearfix">
    <div class="title">{{category_des}}</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="zp" v-for="item of sfc" :key="item.index" wx:key="index"  @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div>

  <!-- <Footer></Footer> -->
  <Box
  :dialogVisible="box.dialogVisible"
  :goods_id="box.goods_id"
  @close="boxClose"
></Box>
</template>

<script>
// import Footer from "@/components/Footer_m";
import Header from "@/components/Header_m";
import Box from "@/components/Box_m";
export default {
  name: "sf_m",
  data() {
    return {
      sf_dt: "https://nicedream.top:8202/gw_lmm/sf1_m.jpg",
      category_sn:"",
      category_des:"",
      sfc:[],
      yz:[],
      jd:null,
      sfd:[],
      box: {
        dialogVisible: false,
        goods_id: "",
      },
    };
  },
  components: { Header,Box },
    created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.category_sn = this.$route.query.id;
      this.category_des=this.$route.query.des;
      this.queryProd()
    }
    },
  mounted() {
  },
  methods:{
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 查询推荐货品
    queryProd() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:this.category_sn,high:0}).then(
        res => {
          if (res.state == 10000) {
            this.sfc=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  }
};
</script>

<style scoped>
/* 顶部图片样式 */
.top-img-wrapper {
  width: 100%;
  overflow: hidden;
}
.top-img-wrapper .wx {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.tbtp {
  height: 150px;
}
.title {
  margin-top: 25px;
  font-size: 22px;
  color: rgb(51, 51, 51);
}
.subtitle {
  font-size: 12px;
  line-height: 25px;
  color: rgb(51, 51, 51);
}

/* 單輪 */
.infinite-list {
  height: 180px;
  padding-left: 5px !important;
}
.infinite-list-item {
  display: inline-block;
  width: 200px;
  height: 150px;
  margin-right: 10px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.dl-tp {
  width: 200px;
  height: 115px;
}
.dl-wz {
  font-size: 13px;
}

/* 展示 */
.zp {
  float: left;
  width: 44vw;
  height: 50vw;
  margin-left: 2.8vw;
  margin-top: 4vw;
  border-radius: 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.zp .el-image {
  width: 44vw;
  height: 40vw;
}
.zpdes {
  font-size: 13px;
}
</style>